import type { MeResponse } from "@agw/contracts";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useMe } from "../features/auth/useMe";
import { ErrorState, PageSpinner } from "../ui";

export function RequireAuth({ children, allow }: { children: (me: MeResponse) => ReactNode; allow?: (me: MeResponse) => boolean }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <PageSpinner />;
  if (me.isError) return <div style={{ padding: 16 }}><ErrorState error={me.error} onRetry={() => void me.refetch()} retrying={me.isFetching} /></div>;
  if (!me.data) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (allow && !allow(me.data)) return <Navigate to="/" replace />;
  return <>{children(me.data)}</>;
}
